export const daysOfWeekLong = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const daysOfWeekShort = ['S', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'];

export function getDayOfTheWeek(dayIndex: number, short: boolean) {
	return short ? daysOfWeekShort[dayIndex] : daysOfWeekLong[dayIndex];
}
